/* afg-guide-bar-fix.js — Sep 07 2026
 *
 * WHY THIS EXISTS
 * The guide/reserve sticky bar (#afgrsv-<uid>-bar) is rendered and styled correctly
 * and its CSS is already in the theme (.on -> display:flex, hidden >=860px). Its
 * activator lives in snippets/afg-hcg-js.liquid and DOES run — verified: that same
 * IIFE creates the .gnav gallery arrows and syncs the .gdot indicators, both of which
 * are present in the DOM. But bar.classList.toggle('on', ...) never takes effect on
 * the live element.
 *
 * Evidence (measured on the real page at 1521px, scrollY 740/1500/4000):
 *   - root rect top was -600 / -1360 / -3860, so the condition (top < -420 &&
 *     bottom > 320) was TRUE at every depth
 *   - the bar never gained .on, and a synthetic scroll event did not toggle it
 *   - adding .on manually STICKS and survives a scroll event
 *   - there is no viewport guard anywhere: no matchMedia, no innerWidth check
 * Conclusion: the element reference captured by that IIFE is stale or detached by the
 * time it toggles. Rather than edit the 12,741-byte snippet and risk its gallery,
 * swatch, duo and fetch-add paths, this re-implements ONLY the bar toggle against a
 * freshly-resolved element on every frame.
 *
 * This is additive and idempotent. It sets no styles of its own — it only applies the
 * class the theme's own CSS already defines. If the original activator starts working,
 * both write the same class and nothing conflicts.
 */
(function () {
  if (window.__afgGuideBarFix) return;
  window.__afgGuideBarFix = true;

  var THRESH_TOP = -420;   // matches the original condition exactly
  var THRESH_BOTTOM = 320;

  function pairs() {
    var out = [];
    var bars = document.querySelectorAll('[id^="afgrsv-"][id$="-bar"]');
    for (var i = 0; i < bars.length; i++) {
      var bar = bars[i];
      var root = document.getElementById(bar.id.replace(/-bar$/, ''));
      if (root) out.push([root, bar]);
    }
    return out;
  }

  var ticking = false;

  function apply() {
    ticking = false;
    var ps = pairs();
    for (var i = 0; i < ps.length; i++) {
      var root = ps[i][0], bar = ps[i][1];
      // Re-resolve by id every pass so a detached or replaced node cannot strand us.
      if (!bar.isConnected) {
        bar = document.getElementById(bar.id);
        if (!bar) continue;
      }
      var r = root.getBoundingClientRect();
      var on = r.top < THRESH_TOP && r.bottom > THRESH_BOTTOM;
      if (on !== bar.classList.contains('on')) bar.classList.toggle('on', on);
    }
  }

  function onScroll() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(apply);
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll, { passive: true });
  window.addEventListener('orientationchange', onScroll, { passive: true });
  document.addEventListener('shopify:section:load', apply);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', apply);
  } else {
    apply();
  }

  // Sections and apps mount late; re-check briefly, then settle.
  var tries = 0;
  var iv = setInterval(function () { apply(); if (++tries > 20) clearInterval(iv); }, 500);
})();
